import { defineMessage } from 'services/localization';

export const messages = {
    contactSalesButtonText: defineMessage('contact_sales_1'),
    contactOwnerButtonText: defineMessage('contact_account_owner'),
    trialMyAccountManageText: defineMessage('manage'),
    trialMyAccountBuyNowText: defineMessage('buy_now'),
    graceMessage: defineMessage('there_seems_to_be_an_is_ural_one_day_other_days'),
    graceMyAccountText: defineMessage('update_payment_details'),
    expiredCommercialOneMessage: defineMessage('the_subscription_for_companyname_expired_on_date'),
    expiredCommercialManyMessage: defineMessage('the_subscription_for_co_sations_expired_on_date'),
    expiredTrialOneMessage: defineMessage('the_trial_for_companyname_expired_on_date'),
    expiredTrialManyMessage: defineMessage('the_trial_for_count_plu_sations_expired_on_date'),
    trialExpiresSingleCompanyMessage: defineMessage('the_trial_for_companyna_ne_in_day_other_in_days'),
    trialExpiresMultipleCompaniesMessage: defineMessage('the_trial_for_count_plu_pires_in_less_than_days'),
    trialContactSalesText: defineMessage('contact_sales_1'),
    expiredTrialUseCaseDefault: defineMessage('get_a_subscription_and__rnal_financial_controls'),
    expiredTrialUseCaseStreamlineAuditProcesses: defineMessage('get_a_subscription_to_streamline_audit_processes'),
    expiredTrialUseCaseEstablishInternalFinancialControls: defineMessage(
        'get_a_subscription_to_e_rnal_financial_controls'
    ),
    expiredTrialUseCaseAutomateApprovalWorkflows: defineMessage('get_a_subscription_to_automate_approval_workflows'),
    expiredTrialUseCaseSpeedupTheApprovalProcess: defineMessage('get_a_subscription_to_s_up_the_approval_process'),
    expiredTrialUseCaseStreamlineAuditProcessesAndEstablishInternalFinancialControls: defineMessage(
        'get_a_subscription_to_s_ols_and_audit_processes'
    ),
    expiredTrialUseCaseStreamlineAuditProcessesAndAutomateApprovalWorkflows: defineMessage(
        'get_a_subscription_to_s__controls_and_approvals'
    ),
    expiredTrialUseCaseStreamlineAuditProcessesAndSpeedupTheApprovalProcess: defineMessage(
        'get_a_subscription_to_s_val_and_audit_processes'
    ),
    expiredTrialUseCaseEstablishInternalFinancialControlsAndAutomateApprovalWorkflows: defineMessage(
        'get_a_subscription_to_a_lish_financial_controls'
    ),
    expiredTrialUseCaseEstablishInternalFinancialControlsAndSpeedupTheApprovalProcess: defineMessage(
        'get_a_subscription_to_s_lish_financial_controls'
    ),
    expiredTrialUseCaseAutomateApprovalWorkflowsAndSpeedupTheApprovalProcess: defineMessage(
        'get_a_subscription_to_a_up_the_approval_process'
    ),
    expiredTrialUseCaseStreamlineAuditProcessesAndEstablishInternalFinancialControlsAndAutomateApprovalWorkflows:
        defineMessage('get_a_subscription_to_e_ne_approvals_and_audits'),
    expiredTrialUseCaseStreamlineAuditProcessesAndEstablishInternalFinancialControlsAndSpeedupTheApprovalProcess:
        defineMessage('get_a_subscription_to_e__and_automate_approvals'),
    expiredTrialUseCaseStreamlineAuditProcessesAndAutomateApprovalWorkflowsAndSpeedupTheApprovalProcess: defineMessage(
        'get_a_subscription_to_s_provals_with_automation'
    ),
    expiredTrialUseCaseEstablishInternalFinancialControlsAndAutomateApprovalWorkflowsAndSpeedupTheApprovalProcess:
        defineMessage('get_a_subscription_to_e_provals_with_automation'),
};
